// src/ConsumerApp/api/savedList/savedList.hooks.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { SavedListService } from './savedList.service';

/**
 * Hook to fetch detailed saved list items[cite: 45]
 */
export const useGetSavedList = (customerId) => {
  return useQuery({
    queryKey: ['savedList', customerId],
    queryFn: async () => {
      const res = await SavedListService.getSavedList(customerId);
      const data = Array.isArray(res) ? res : res?.data || res?.items || [];
      return data;
    },
    enabled: Boolean(customerId),
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * Hook to add item to saved list[cite: 45]
 */
export const useAddItemToSavedList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => SavedListService.addItemToSavedList(payload),
    onSuccess: (_, variables) => {
      const customerId = variables?.customer_id;
      if (customerId) {
        queryClient.invalidateQueries({ queryKey: ['savedList', customerId] });
        queryClient.invalidateQueries({ queryKey: ['bucketSummary', customerId] });
        queryClient.invalidateQueries({ queryKey: ['bucketDetails', customerId] });
      }
    },
  });
};

/**
 * Hook to remove item from saved list[cite: 45]
 */
export const useRemoveItemFromSavedList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => SavedListService.removeItemFromSavedList(payload),
    onSuccess: (_, variables) => {
      const customerId = variables?.customer_id;
      if (customerId) {
        queryClient.invalidateQueries({ queryKey: ['savedList', customerId] });
      }
    },
  });
};